export enum OrdersActionTypes {
    START_REQUEST = 'ORDERS_START_REQUEST',
    END_REQUEST = 'ORDERS_END_REQUEST',
    GET_RECENT_ORDERS_SUCCESS = 'GET_RECENT_ORDERS_SUCCESS',
    GET_RECENT_ORDERS_ERROR = 'GET_RECENT_ORDERS_ERROR'
}
